export default {
  find: [],
  read: [],
  background: null,
  textSelect: {},
  type: null,
  isTextSelected: false,
};
